// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"ef7550cb","220":"17883e9f","665":"73379aa0"}[chunkId] + ".chunk.css";
};